<app-spinner-service></app-spinner-service>

<app-toolbar-search 
  [showDateFilters]="true" 
  [showDownloadButton]="true" 
  [(dataInicio)]="dataInicio"
  [(dataFim)]="dataFim" 
  (onDateChange)="onDateChange()" 
  (onDownload)="downloadExcel()"
  (onSearch)="applyFilterGlobal($event)" 
  placeholder="Pesquisar razão...">
</app-toolbar-search>

<p-table #dt 
  [value]="transacoesFiltradas" 
  [paginator]="true" 
  [rows]="50"
  [globalFilterFields]="['contaContabil.descricao', 'dataTransacao', 'historico', 'debito', 'credito', 'valorFinal', 'tipoTransacao', 'contaContrapartida']"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
  class="custom-table"
  [loading]="loading"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[5, 10, 20, 50]">

  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="contaContabil.descricao" style="width: 18%">
        Conta Contábil <p-sortIcon field="contaContabil.descricao"></p-sortIcon>
      </th>
      <th pSortableColumn="dataTransacao" style="width: 10%">
        Data <p-sortIcon field="dataTransacao"></p-sortIcon>
      </th>
      <th pSortableColumn="historico" style="width: 25%">
        Histórico <p-sortIcon field="historico"></p-sortIcon>
      </th>
      <th pSortableColumn="debito" style="width: 12%">
        Débito <p-sortIcon field="debito"></p-sortIcon>
      </th>
      <th pSortableColumn="credito" style="width: 12%">
        Crédito <p-sortIcon field="credito"></p-sortIcon>
      </th>
      <th pSortableColumn="valorFinal" style="width: 12%">
        Saldo <p-sortIcon field="valorFinal"></p-sortIcon>
      </th>
      <th pSortableColumn="tipoTransacao" style="width: 11%">
        Natureza <p-sortIcon field="tipoTransacao"></p-sortIcon>
      </th>
      <th pSortableColumn="contaContrapartida" style="width: 12%">
        Conta de Contrapartida <p-sortIcon field="contaContrapartida"></p-sortIcon>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-transacao>
    <tr>
      <td>
        <div class="account-content">
          <i class="pi pi-tag account-icon"></i>
          <span class="account-text" [pTooltip]="transacao.contaContabil.descricao" tooltipPosition="top">{{ transacao.contaContabil.descricao }}</span>
        </div>
      </td>
      <td>
        <div class="date-content">
          <i class="pi pi-calendar date-icon"></i>
          <span class="date-text" [pTooltip]="transacao.dataTransacao | date:'dd/MM/yyyy'" tooltipPosition="top">{{ transacao.dataTransacao | date:'dd/MM/yyyy' }}</span>
        </div>
      </td>
      <td>
        <div class="history-content">
          <i class="pi pi-align-left history-icon"></i>
          <span class="history-text" [pTooltip]="transacao.historico" tooltipPosition="top">{{ transacao.historico }}</span>
        </div>
      </td>
      <td>
        <div class="debit-content">
          <i class="pi pi-minus-circle debit-icon"></i>
          <span class="debit-text" [pTooltip]="formataValorPositivoHelper.formatarSaldoPositivo(transacao.debito) | currency:'BRL':'symbol'" tooltipPosition="top">{{ formataValorPositivoHelper.formatarSaldoPositivo(transacao.debito) | currency:'BRL':'symbol' }}</span>
        </div>
      </td>
      <td>
        <div class="credit-content">
          <i class="pi pi-plus-circle credit-icon"></i>
          <span class="credit-text" [pTooltip]="formataValorPositivoHelper.formatarSaldoPositivo(transacao.credito) | currency:'BRL':'symbol'" tooltipPosition="top">{{ formataValorPositivoHelper.formatarSaldoPositivo(transacao.credito) | currency:'BRL':'symbol' }}</span>
        </div>
      </td>
      <td>
        <div class="balance-content">
          <i class="pi pi-calculator balance-icon"></i>
          <span class="balance-text" [pTooltip]="formataValorPositivoHelper.formatarSaldoPositivo(transacao.valorFinal) | currency:'BRL':'symbol'" tooltipPosition="top">{{ formataValorPositivoHelper.formatarSaldoPositivo(transacao.valorFinal) | currency:'BRL':'symbol' }}</span>
        </div>
      </td>
      <td>
        <div class="nature-content" *ngIf="transacao.valorFinal !== 0">
          <i class="pi pi-info-circle nature-icon"></i>
          <span class="nature-text" [pTooltip]="transacao.descricaoTipoTransacao" tooltipPosition="top">{{ transacao.descricaoTipoTransacao }}</span>
        </div>
      </td>
      <td>
        <div class="counterpart-content">
          <i class="pi pi-tag counterpart-icon"></i>
          <span class="counterpart-text" [pTooltip]="transacao.contaContrapartida || 'Sem contrapartida'" tooltipPosition="top">{{ transacao.contaContrapartida || 'Sem contrapartida' }}</span>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="8" class="empty-message">
        <div class="empty-content">
          <i class="pi pi-book" style="font-size: 3rem; color: #6c757d; margin-bottom: 1rem;"></i>
          <h3>Nenhum razão encontrado</h3>
          <p>Não há dados de razão para o período selecionado.</p>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<div class="p-d-flex p-jc-end" style="margin-top: 1%;">
  <button pButton label="Voltar" icon="pi pi-arrow-left" class="p-button-secondary" (click)="voltar()"></button>
</div>